'use client';

import styles from './DocumentsAsideHeader.module.css';
import { type FC } from 'react';
import {
  CardHeader,
  DocumentsNavigation,
  Flex,
  Icon,
  Text,
} from '@/_components';
import type { DocumentsAsideHeaderProps } from './DocumentsAsideHeader.types';

export const DocumentsAsideHeader: FC<DocumentsAsideHeaderProps> = () => {
  return (
    <CardHeader>
      <Flex
        gap={4}
        isYCentered={true}
        isBetween={true}
        className={styles.documentsAsideHeader}
      >
        <Flex gap={4} isYCentered={true}>
          <Icon name="cloud" size={20} />
          <Text>All Files</Text>
        </Flex>
        <DocumentsNavigation />
      </Flex>
    </CardHeader>
  );
};
